/*
 * Re-mount the ecomid eco-impact widget after in-place product changes.
 */
(function () {
  var FLAG = 'data-ecomid-widget-reinited';
  var MOUNT_SELECTOR = '#widget';
  var INIT_NEEDLE = 'initWidget';

  function reinit() {
    var scripts = document.querySelectorAll('script[type="module"]:not([' + FLAG + '])');
    Array.prototype.forEach.call(scripts, function (oldScript) {
      if ((oldScript.textContent || '').indexOf(INIT_NEEDLE) === -1) return;

      var s = document.createElement('script');
      s.type = 'module';
      s.textContent = oldScript.textContent;
      s.setAttribute(FLAG, 'true');
      oldScript.setAttribute(FLAG, 'true');
      oldScript.parentNode.replaceChild(s, oldScript);
    });
  }

  function flagExisting() {
    var scripts = document.querySelectorAll('script[type="module"]:not([' + FLAG + '])');
    Array.prototype.forEach.call(scripts, function (sc) {
      if ((sc.textContent || '').indexOf(INIT_NEEDLE) !== -1) {
        sc.setAttribute(FLAG, 'true');
      }
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      reinit();
    });
  }

  function init() {
    flagExisting();

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type !== 'childList') continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (
            (n.matches && n.matches(MOUNT_SELECTOR)) ||
            (n.querySelector && n.querySelector(MOUNT_SELECTOR))
          ) {
            schedule();
            return;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
